import { z } from 'zod';
import { DiscountTypesSchema } from './DiscountTypes.js';
import { paymentTypeSchema } from './PaymentConfig.js';

const applicableForSchema = z.union([
    z.array(z.union([paymentTypeSchema, z.literal('ALL')])),
    z.literal('ALL'),
]);
const discountCampaignSchema = z
    .object({
    /** The discount amount */
    amount: z.number(),
    /** Product IDs that this discount can be applied to */
    applicableTo: z.array(z.string()),
    /** The discount code buyers enter at checkout (for non-automatic discounts) */
    code: z.string().optional(),
    endsAt: z.number(),
    id: z.string(),
    name: z.string().optional(),
    startsAt: z.number(),
    /** Type of discount */
    type: DiscountTypesSchema,
    /** Payment options that this discount can be paired with */
    applicableFor: applicableForSchema,
    /** If true, the discount will be applied automatically to the cart */
    autoApply: z.boolean().optional(),
})
    .refine((data) => data.code || data.name, {
    message: 'At least one of "code" or "name" is required',
    path: ['code'],
});

export { discountCampaignSchema };
//# sourceMappingURL=DiscountCampaign.js.map
